import type { ReactElement } from "react";
import { MAX_INSIGHT_TOOLTIP_WIDTH } from "./const";
import { StyledInsightTooltip, StyledTooltipTrigger } from "./styles";

type Props = {
    debounce?: number;
    placement?: string;
    content: ReactElement | string | number;
    children: ReactElement | string | number;
};

const InsightTooltip = (props: Props) => {
    const { debounce, content, children, placement = "top" } = props;

    return (
        <StyledInsightTooltip
            variation="white"
            placement={placement}
            maxWidth={MAX_INSIGHT_TOOLTIP_WIDTH}
            tooltipContent={content}
            debounce={debounce}
        >
            <StyledTooltipTrigger>{children}</StyledTooltipTrigger>
        </StyledInsightTooltip>
    );
};

export default InsightTooltip;
